<template>
    <div>
        <form @submit.prevent="formSubmit">
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="component_area">{{ $t('omsz-form.labels.components_area') }}</label>
                    <div class="select-container">
                        <multiselect id="component_area"
                                     v-model="area"
                                     track-by="name"
                                     label="name"
                                     :placeholder="$t('omsz-form.placeholders.select')"
                                     :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                     :selectedLabel="$t('omsz-form.placeholders.selected')"
                                     :deselect-label="$t('omsz-form.placeholders.remove')"
                                     :options="filters.competences" :allow-empty="false"
                                     :searchable="true"
                                     :disabled="isDisabled"
                                     @select="areaSelect">
                            <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                            <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                        </multiselect>
                        <span v-if="area" @click="clearAll" class="close-tag">
                            <i class="icon icon-close"></i>
                        </span>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label for="country">{{ $t('omsz-form.labels.country') }}</label>
                    <div class="select-container">
                        <multiselect id="country"
                                     v-model="country"
                                     track-by="name"
                                     label="name"
                                     :placeholder="$t('omsz-form.placeholders.select')"
                                     :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                     :selectedLabel="$t('omsz-form.placeholders.selected')"
                                     :deselect-label="$t('omsz-form.placeholders.remove')"
                                     :options="filters.regions"
                                     :allow-empty="false"
                                     :searchable="true"
                                     :disabled="isDisabled"
                                     @select="countrySelect">
                            <template slot="country" slot-scope="{ option }"><strong>{{ option.name }}</strong>
                            </template>
                            <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                        </multiselect>
                        <span v-if="country" @click="clearAll" class="close-tag">
                             <i class="icon icon-close"></i>
                        </span>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <label for="zone">{{ $t('omsz-form.labels.air_pollution_zone') }}</label>
                    <div class="select-container">
                        <multiselect id="zone"
                                     v-model="zone"
                                     track-by="name"
                                     label="name"
                                     :placeholder="$t('omsz-form.placeholders.select')"
                                     :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                     :selectedLabel="$t('omsz-form.placeholders.selected')"
                                     :deselect-label="$t('omsz-form.placeholders.remove')"
                                     :options="filters.zones"
                                     :allow-empty="false"
                                     :searchable="true"
                                     :disabled="isDisabled"
                                     @select="zoneSelect">
                            <template slot="zone" slot-scope="{ option }"><strong>{{ option.name }}</strong></template>
                            <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                        </multiselect>
                        <span v-if="zone" @click="clearAll" class="close-tag">
                            <i class="icon icon-close"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="city">{{ $t('omsz-form.labels.city') }}</label>
                    <multiselect id="city"
                                 v-model="city"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select_city')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 open-direction="bottom"
                                 :options="filters.cities"
                                 :multiple="true"
                                 :searchable="true"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :hide-selected="true"
                                 @input="selectCity">
                        <template slot="tag" slot-scope="{ option, remove }">
                            <span class="multiselect__tag">
                                <span>{{ option.name }}</span>
                                <span class="multiselect__tag-icon" @click="remove(option)"></span>
                            </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-show="city.length > 1"
                                 @mousedown.prevent.stop="clearArray('city')"></div>
                        </template>
                        <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                    </multiselect>
                </div>
                <div class="form-group col-md-6">
                    <label for="stations">{{ $t('omsz-form.labels.stations') }} <span
                        class="text-danger">*</span></label>
                    <multiselect id="stations"
                                 v-model="station"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select_city')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 open-direction="bottom"
                                 :options="filters.stations"
                                 :multiple="true"
                                 :searchable="searchable.station"
                                 :max="max.station"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :hide-selected="true"
                                 @input="selectStation">
                        <template slot="tag" slot-scope="{ option, remove }">
                            <span class="multiselect__tag">
                                <span>{{ option.name }}</span>
                                <span class="multiselect__tag-icon" @click="remove(option)"></span>
                            </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-show="station.length > 1"
                                 @mousedown.prevent.stop="clearArray('station')"/>
                        </template>
                        <span slot="maxElements">{{ $t('omsz-form.errors.max', { max: 1 }) }}</span>
                        <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                    </multiselect>
                </div>
            </div>
            <div class="form-row justify-content-between">
                <div class="form-group col-md-4">
                    <label for="measured_components">{{ $t('omsz-form.labels.measured_components') }} <span
                        class="text-danger">*</span></label>
                    <multiselect id="measured_components"
                                 v-model="element"
                                 label="name"
                                 track-by="name"
                                 :placeholder="$t('omsz-form.placeholders.select_element')"
                                 :selectLabel="$t('omsz-form.placeholders.select_enter')"
                                 :selectedLabel="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 open-direction="bottom"
                                 :options="filters.elements"
                                 :multiple="true"
                                 :searchable="searchable.element"
                                 :max="max.element"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :hide-selected="true"
                                 :allow-empty="true"
                                 @input="selectElements">
                        <template slot="tag" slot-scope="{ option, remove }">
                            <span class="multiselect__tag">
                                <span>{{ option.name }}</span>
                                <span class="multiselect__tag-icon" @click="remove(option)"></span>
                            </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-show="element.length > 1"
                                 @mousedown.prevent.stop="clearArray('element')"/>
                        </template>
                        <span slot="maxElements">{{ $t('omsz-form.errors.max', { max: 1 }) }}</span>
                        <span slot="noResult">{{ $t('omsz-form.errors.not_found') }}</span>
                    </multiselect>
                </div>
                <div class="form-group col-md-3">
                    <label for="start_date">{{ $t('omsz-form.labels.stat_date') }} <span
                        class="text-danger">*</span></label>
                    <date-picker id="start_date"
                                 v-model="startDate"
                                 :format="format"
                                 :editable="false"
                                 :default-value="endDate || new Date()"
                                 :disabled-date="notBeforeToday"
                                 :allow-empty="false">
                        <i slot="icon-calendar" class="icon icon-calendar"/>
                    </date-picker>
                </div>
                <div class="form-group col-md-3">
                    <label for="end_date">{{ $t('omsz-form.labels.end_date') }} <span
                        class="text-danger">*</span></label>
                    <date-picker id="end_date"
                                 v-model="endDate"
                                 :format="format"
                                 :editable="false"
                                 :default-value="startDate || new Date()"
                                 :disabled-date="notBeforeToday"
                                 :allow-empty="false">
                        <i slot="icon-calendar" class="icon icon-calendar"/>
                    </date-picker>
                </div>
                <div class="form-group col-md-2">
                    <label>{{ $t('omsz-form.labels.timebase') }}</label>
                    <div class="measured-form-radio">
                        <div class="form-check">
                            <input type="radio"
                                   id="timebase_hour"
                                   name="timebase"
                                   class="form-check-input"
                                   value="hour"
                                   v-model="checked">
                            <label for="timebase_hour" class="form-check-label">
                                {{ $t('omsz-form.labels.date.hour') }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input type="radio"
                                   id="timebase_day"
                                   name="timebase"
                                   class="form-check-input"
                                   value="day"
                                   v-model="checked">
                            <label for="timebase_day" class="form-check-label">
                                {{ $t('omsz-form.labels.date.day') }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row justify-content-end mb-3" v-if="siteKey">
                <vue-recaptcha :sitekey="siteKey" ref="recaptcha" @verify="onVerify" @expired="onExpired" class="col-auto"></vue-recaptcha>
            </div>
            <div class="form-row justify-content-end">
                <div class="form-group buttons ml-auto d-flex align-items-end">
                    <button
                        id="clear_form"
                        type="button"
                        class="btn btn-link text-uppercase mr-3"
                        :disabled="!(station.length && element.length && startDate && endDate) || isLoading"
                        @click="clearAll">
                        <span>{{ $t('omsz.buttons.clear_filters') }}</span>
                    </button>
                    <button id="send" class="btn btn-primary" type="submit"
                            :disabled="!(station.length && element.length && startDate && endDate && isRecaptchaValid()) || isLoading"
                            :class="{'loader': isLoading}">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>
        <div class="row" v-if="errorMessage">
            <div class="col-auto">
                {{ errorMessage }}
            </div>
        </div>
        <div v-if="chartData || tableData">
            <p><span class="text-primary">*</span> {{$t('omsz-form.message.information_only')}}</p>
            <line-chart v-if="chartData" :chart-data="chartData" :width="420" :height="270"/>
            <automatic-table v-if="tableData" :datas="tableData"/>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import AutomaticTable from "./AutomaticTable";
import LineChart from './../components/LineChart';

export default {
    name: 'automatic-network',
    components: {
        Multiselect,
        DatePicker,
        VueRecaptcha,
        AutomaticTable,
        LineChart
    },
    props: {
        defaults: {
            type: Object,
            required: true
        },
        stationfromlink: {
            type: Array
        },
		elementfromlink: {
			type: Array
		}
    },
    data() {
        return {
            filters: this.defaults,
            area: null,
            country: null,
            zone: null,
            city: [],
            station: [],
            element: [],
            startDate: null,
            endDate: null,
            searchable: {
                station: true,
                element: true
            },
            max: {
                station: null,
                element: null,
            },
            format: 'YYYY-MM-DD',
            checked: 'hour',
            isLoading: false,
            isDisabled: false,
            errorMessage: null,
            tableData: null,
            chartData: null,
            siteKey: window.Met.recaptcha.site_key || null,
            recaptchaToken: null,
        };
    },
    created() {
        if (this.stationfromlink) {
            this.station = this.stationfromlink;
            this.selectStation(this.stationfromlink);
			if(this.elementfromlink){
				this.element = this.elementfromlink;
				this.selectElements(this.elementfromlink);
			}
        }
    },
    methods: {
        clearAll(e) {
            this.area = null;
            this.country = null;
            this.zone = null;
            this.city = [];
            this.station = [];
            this.element = [];
            this.startDate = null;
            this.endDate = null;
            this.checked = 'hour';
            this.tableData = null;
            this.chartData = null;
            this.isDisabled = false;
            this.select();
        },
        clearArray(key) {
            if (key === 'city') {
                this.city = [];
                this.data('cities')
            }
            if (key === 'station') {
                this.station = [];
                this.max.element = null;
                this.searchable.element = true;
            }
            if (key === 'element') {
                this.element = [];
                this.max.station = null;
                this.searchable.station = true;
            }
        },
        areaSelect(e) {
            this.isDisabled = true;
            this.data('competence', e.id);
        },
        countrySelect(e) {
            this.isDisabled = true;
            this.data('region', e.id);
        },
        zoneSelect(e) {
            this.isDisabled = true;
            this.data('zone', e.id);
        },
        selectCity(e) {
            const cityArray = e.map(item => item.id);
            this.data('cities', cityArray);
        },
        selectStation(e) {
            const stationArray = e.map(item => item.id)
            if(e.length > 0) {
                this.data('stations', stationArray)
            }

            this.max.element = null;
            this.searchable.element = true;

            if (e.length > 1) {
                this.max.element = 1;
                this.searchable.element = !this.searchable.element;
            }
        },
        selectElements(e) {
            const elementArray = e.map(item => item.id);
            this.data('elements', elementArray);
            this.max.station = null;
            this.searchable.station = true;

            if (e.length > 1) {
                this.max.station = 1;
                this.searchable.station = !this.searchable.station;
            }
        },
        data(key, value) {
            const item = {};
            item[key] = value;
            return this.select(item);
        },
        notBeforeToday(date) {
            let today =  new Date();
            const oldestDay = new Date('2004-01-01');

            if(this.startDate) {
                return date < this.startDate || date >= new Date(this.startDate.getTime() + 366 * 24 * 3600 * 1000) || date >= today;
            } else if (this.endDate) {
                return date <= new Date(this.endDate.getTime() - 366 * 24 * 3600 * 1000) || date > this.endDate ;
            }

            return date <= oldestDay || date > today
        },
        async onVerify(response) {
            if (response) {
                this.recaptchaToken = response;
            }
        },
        onExpired() {
            this.recaptchaToken = null;
        },
        isRecaptchaValid() {
            return (this.$environment === 'local' && !this.siteKey) || this.recaptchaToken;
        },

        async select(e) {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            try {
                const { data } = await axios.get(`/api/automatic-network/history/filters?`, {
                    headers: { 'Accept-Language': window.Met.locale },
                    params: e,
                })

                this.filters = Object.assign(this.filters, data);
            } catch (error) {
                this.errorMessage = this.$t('omsz-form.errors.no_result');
            } finally {
                this.isLoading = false;
            }
        },
        async formSubmit(e) {
            if (!this.isRecaptchaValid()) {
                this.errorMessage = this.$t('omsz-form.errors.recaptcha_required');
            }

            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            this.tableData = null;
            this.chartData = null;
            this.errorMessage = null;

            const allParams = {
                cities: this.city.map(item => item.id),
                stations: this.station.map(item => item.id),
                elements: this.element.map(item => item.id),
                from_date: moment(this.startDate).format(),
                to_date: moment(this.endDate).format(),
                timespan: this.checked,
            };

            if (this.recaptchaToken) {
                allParams.recaptcha_token = this.recaptchaToken;
            }

            try {
                const response = await axios.get(`/api/automatic-network/history/data?`,
                    {
                        headers: { 'Accept-Language': window.Met.locale },
                        params: allParams,
                    })

                this.tableData = response.data.table;
                this.chartData = Object.assign({},response.data.chart);
            } catch (error) {
                if (error.response.status === 403) {
                    // TODO: need better error handling
                    this.errorMessage = this.$t('omsz-form.errors.recaptcha_failed');
                } else {
                    this.errorMessage = this.$t('omsz-form.errors.not_response');
                }
            } finally {
                this.isLoading = false;
                this.$refs.recaptcha.reset();
            }
        }
    }
}
</script>
